import { fontSizes } from '@enechain/ecloud-designsystem'

import { TABLE_HEADER_BG } from '~/pages/AdminApprovalFlow/components/matrixStyles'
import { eclColor } from '~/pages/AdminApprovalFlow/constants/eclColor'

type AreaHeaderCellProps = {
  areaLabel: string
}

/** エリア列ヘッダ (`<th>`)。 */
export const AreaHeaderCell = ({
  areaLabel,
}: AreaHeaderCellProps): React.ReactElement => (
  <th
    style={{
      background: TABLE_HEADER_BG,
      padding: '8px 10px',
      border: 'none',
      borderBottom: `1px solid ${eclColor.borderLow}`,
      textAlign: 'center',
      fontWeight: 600,
      fontSize: fontSizes.md.value,
      whiteSpace: 'nowrap',
      color: eclColor.textHigh,
    }}
  >
    {areaLabel}
  </th>
)
